import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import SiteLayout from "@/components/site/SiteLayout";
import ArticleCard from "@/components/site/ArticleCard";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!q) { setItems([]); setLoading(false); return; }
    setLoading(true);
    api.get("/articles", { params: { q, limit: 60 } })
      .then((r) => setItems(r.data || []))
      .finally(() => setLoading(false));
  }, [q]);

  return (
    <SiteLayout>
      <div className="max-w-7xl mx-auto px-4 py-10">
        <div className="border-b-4 border-[#2E7D32] pb-4 mb-8">
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#2E7D32]">వెతకిన పదం</div>
          <h1 className="font-heading-te text-3xl md:text-4xl font-black mt-1" data-testid="search-heading">
            "{q}"
          </h1>
        </div>
        {loading ? (
          <div className="text-center py-16 font-body-te">వెతుకుతోంది...</div>
        ) : items.length === 0 ? (
          <div className="text-center py-16 font-body-te text-[#4A4A4A]" data-testid="search-empty">
            ఫలితాలు కనిపించలేదు.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="search-results">
            {items.map((a) => <ArticleCard key={a.id} article={a} />)}
          </div>
        )}
      </div>
    </SiteLayout>
  );
}
